<template>
  <div class="layout-container">
    <el-container>
      <el-aside :width="isCollapse ? '64px' : '200px'" class="aside">
        <div class="logo" @click="isCollapse = !isCollapse">
          <h1 v-show="!isCollapse">{{ siteSettings.siteName }}</h1>
          <el-icon v-show="isCollapse"><Menu /></el-icon>
        </div>
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical"
          :collapse="isCollapse"
          background-color="#0A1A35"
          text-color="#ffffff"
          active-text-color="#ffffff"
          @select="handleSelect"
        >
          <el-menu-item index="/dashboard">
            <el-icon><DataLine /></el-icon>
            <span>数据概况</span>
          </el-menu-item>

          <el-sub-menu index="/auth">
            <template #title>
              <el-icon><Key /></el-icon>
              <span>授权管理</span>
            </template>
            <el-menu-item index="/auth/list">
              <el-icon><List /></el-icon>
              <span>授权列表</span>
            </el-menu-item>
            <el-menu-item index="/auth/recycle">
              <el-icon><Delete /></el-icon>
              <span>回收站</span>
            </el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="/app-auth">
            <template #title>
              <el-icon><Files /></el-icon>
              <span>APP授权</span>
            </template>
            <el-menu-item index="/app-auth/list">
              <el-icon><Document /></el-icon>
              <span>APP授权列表</span>
            </el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="/service">
            <template #title>
              <el-icon><Service /></el-icon>
              <span>服务管理</span>
            </template>
            <el-menu-item index="/service/sms">
              <el-icon><Message /></el-icon>
              <span>短信服务</span>
            </el-menu-item>
            <!-- <el-menu-item index="/service/insurance">
              <el-icon><Umbrella /></el-icon>
              <span>保险服务</span>
            </el-menu-item>
            <el-menu-item index="/service/payment">
              <el-icon><CreditCard /></el-icon>
              <span>支付设置</span>
            </el-menu-item> -->
          </el-sub-menu>

          <el-sub-menu index="/code">
            <template #title>
              <el-icon><Files /></el-icon>
              <span>代码管理</span>
            </template>
            <el-menu-item index="/code/frontend">
              <el-icon><Document /></el-icon>
              <span>前端代码</span>
            </el-menu-item>
            <el-menu-item index="/code/backend">
              <el-icon><Cpu /></el-icon>
              <span>后端代码</span>
            </el-menu-item>
          </el-sub-menu>

          <el-sub-menu index="/provider">
            <template #title>
              <el-icon><Connection /></el-icon>
              <span>服务商管理</span>
            </template>
            <el-menu-item index="/provider/access">
              <el-icon><Link /></el-icon>
              <span>服务商接入</span>
            </el-menu-item>
            <el-menu-item index="/provider/resource">
              <el-icon><Coin /></el-icon>
              <span>服务商资源</span>
            </el-menu-item>
            <el-menu-item index="/provider/mp-auth">
              <el-icon><Cellphone /></el-icon>
              <span>小程序授权</span>
            </el-menu-item>
          </el-sub-menu>

          <el-sub-menu index="/settings">
            <template #title>
              <el-icon><Setting /></el-icon>
              <span>系统设置</span>
            </template>
            <el-menu-item index="/settings/site">
              <el-icon><Setting /></el-icon>
              <span>站点设置</span>
            </el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>

      <el-container>
        <el-header height="50px" class="header">
          <div class="header-left">
            <div class="breadcrumb-container">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                  <el-icon><HomeFilled /></el-icon>
                  <span>首页</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item
                  v-for="(item, index) in breadcrumbs"
                  :key="index"
                  :to="item.path"
                >
                  {{ item.title }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="header-right">
            <el-popover
              placement="bottom-end"
              :width="350"
              trigger="click"
              popper-class="message-popover"
            >
              <template #reference>
                <div class="message-icon">
                  <el-badge :value="unreadCount" :max="99" class="notice-badge">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                      <path fill="#909399" d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"/>
                    </svg>
                  </el-badge>
                </div>
              </template>

              <template #default>
                <div class="message-panel">
                  <div class="message-header">
                    <span class="title">消息通知</span>
                    <el-link type="primary" @click="handleReadAll" :disabled="!unreadCount">
                      全部已读
                    </el-link>
                  </div>
                  <el-tabs v-model="activeTab">
                    <el-tab-pane label="申请通知" name="todo">
                      <div class="message-list" v-loading="loading">
                        <template v-if="todoList.length">
                          <div
                            v-for="item in todoList"
                            :key="item.id"
                            class="message-item"
                            :class="{ unread: !item.isRead }"
                            @click="handleMessageClick(item)"
                          >
                            <div class="message-content">
                              <div class="message-title">
                                <el-tag size="small" :type="getTagType(item.type)">{{ item.type }}</el-tag>
                                {{ item.title }}
                              </div>
                              <div class="message-desc">{{ item.content }}</div>
                              <div class="message-time">{{ item.createTime }}</div>
                            </div>
                          </div>
                        </template>
                        <el-empty v-else description="暂无申请通知" />
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="系统通知" name="notice">
                      <div class="message-list" v-loading="loading">
                        <template v-if="noticeList.length">
                          <div
                            v-for="item in noticeList"
                            :key="item.id"
                            class="message-item"
                            :class="{ unread: !item.isRead }"
                            @click="handleMessageClick(item)"
                          >
                            <div class="message-content">
                              <div class="message-title">
                                <el-tag size="small" type="danger">{{ item.type }}</el-tag>
                                {{ item.title }}
                              </div>
                              <div class="message-desc">{{ item.content }}</div>
                              <div class="message-time">{{ item.createTime }}</div>
                            </div>
                          </div>
                        </template>
                        <el-empty v-else description="暂无系统通知" />
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                  <div class="message-footer">
                    <el-button text @click="handleReadAll">全部已读</el-button>
                  </div>
                </div>
              </template>
            </el-popover>

            <el-dropdown trigger="click">
              <div class="user-info">
                <el-avatar :size="32" :src="userAvatar" />
                <span class="username">{{ username }}</span>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="showProfileDialog">
                    <el-icon><Edit /></el-icon>修改资料
                  </el-dropdown-item>
                  <el-dropdown-item @click="handleLogout">
                    <el-icon><SwitchButton /></el-icon>退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>

        <TabBar />

        <el-main class="main">
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </el-main>
        <el-footer class="main-footer" height="auto">
          <div class="footer-content">
            <div class="footer-info">
              <span class="copyright">{{ siteSettings.copyright }}</span>
              <span class="divider">|</span>
              <span class="icp">{{ siteSettings.icp }}</span>
              <span class="divider">|</span>
              <span class="version">系统版本：{{ siteSettings.version }}</span>
            </div>
            <div class="footer-contact">
              <span class="tech-support">{{ siteSettings.techSupport }}</span>
              <span class="divider">|</span>
              <span class="service-phone">服务电话：{{ siteSettings.servicePhone }}</span>
            </div>
          </div>
        </el-footer>
      </el-container>
    </el-container>

    <!-- 个人资料弹窗 -->
    <el-dialog
      v-model="profileDialogVisible"
      title="管理员密码修改"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="profileFormRef"
        :model="profileForm"
        :rules="profileRules"
        label-width="80px"
      >


        <el-form-item label="用户名" prop="username">
          <el-input v-model="profileForm.username" placeholder="输入用户名" disabled />
        </el-form-item>

        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="profileForm.oldPassword"
            type="password"
            placeholder="请输入原密码"
            show-password
          />
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="profileForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          />
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="profileForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="profileDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleProfileSubmit" :loading="profileLoading">
            保存
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, reactive, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  Menu,
  Key,
  List,
  Delete,
  Cellphone,
  Service,
  Message,
  Umbrella,
  Document,
  Cpu,
  Files,
  Setting,
  Tools,
  Lock,
  User,
  DataLine,
  Bell,
  HomeFilled,
  Edit,
  SwitchButton,
  CreditCard,
  Connection,
  Link,
  Coin
} from '@element-plus/icons-vue'
import { useTaskStore } from '@/stores/task'
import TabBar from '@/components/layout/TabBar.vue'
import { ElMessage } from 'element-plus'
import { storage, STORAGE_KEYS } from '@/utils/storage'
import { removeToken } from '@/utils/auth'
import { user } from '@/api'
import { clearBrowserPasswordData } from '@/utils/browserSecurity'

const route = useRoute()
const router = useRouter()
const taskStore = useTaskStore()



const isCollapse = ref(false)
const username = ref('管理员')
const userAvatar = ref('/images/admin-avatar.png')

// 计算当前激活的菜单项
const activeMenu = computed(() => route.path)

// 计算面包屑
const breadcrumbs = computed(() => {
  const matched = route.matched.filter(item => item.meta && item.meta.title)
  return matched.map(item => ({
    title: item.meta.title,
    path: item.path
  }))
})

// 监听路由变化，添加到任务栏
watch(() => route.path, () => {
  if (route.meta?.title && !route.meta?.hideInTaskbar) {
    taskStore.addView(route)
  }
}, { immediate: true })

// 处理菜单选择
const handleSelect = (key) => {
  const menuMap = {
    '/dashboard': { title: '数据概况', icon: 'DataLine' },
    '/auth/list': { title: '授权列表', icon: 'List' },
    '/auth/recycle': { title: '回收站', icon: 'Delete' },
    '/app-auth': { title: 'APP授权', icon: 'Cellphone' },
    '/service/sms': { title: '短信服务', icon: 'Message' },
    '/service/insurance': { title: '保险服务', icon: 'Umbrella' },
    '/service/payment': { title: '支付设置', icon: 'CreditCard' },
    '/code/frontend': { title: '前端代码', icon: 'Document' },
    '/code/backend': { title: '后端代码', icon: 'Cpu' },
    '/provider/access': { title: '服务商接入', icon: 'Link' },
    '/provider/resource': { title: '服务商资源', icon: 'Coin' },
    '/provider/mp-auth': { title: '小程序授权', icon: 'Cellphone' },
    '/settings/site': { title: '站点设置', icon: 'Setting' }
  }

  router.push({
    path: key,
    meta: menuMap[key] || {}
  })
}

// 处理退出登录
const handleLogout = async () => {
  try {
    // 调用后端logout接口清理服务器端session
    const response = await fetch('/api/auth/logout', {
      method: 'POST',
      credentials: 'include', // 包含cookie以维持session
      headers: {
        'Content-Type': 'application/json'
      }
    })

    const result = await response.json()

    if (response.ok && (result.code === 0 || result.code === 200)) {
      ElMessage.success('退出成功')
    } else {
      console.warn('后端退出接口调用失败:', result.msg)
      // 即使后端退出失败，也继续执行前端清理
    }
  } catch (error) {
    console.error('退出登录请求失败:', error)
    // 即使请求失败，也继续执行前端清理
  }

  // 清理前端数据
  removeToken()
  taskStore.clearViews() // 清空任务栏

  // 清除浏览器保存的密码数据
  clearBrowserPasswordData()

  // 跳转到登录页
  router.push('/login')
}

// 个人资料相关
const profileDialogVisible = ref(false)
const profileFormRef = ref(null)
const profileLoading = ref(false)

const profileForm = reactive({
  avatar: '/images/admin-avatar.png',
  username: 'admin',
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
})

const validatePass2 = (rule, value, callback) => {
  if (value === '') {
    callback()
  } else if (value !== profileForm.newPassword) {
    callback(new Error('两次输入密码不一致！'))
  } else {
    callback()
  }
}

const profileRules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
  ],
  oldPassword: [
    {
      validator: (rule, value, callback) => {
        if (profileForm.newPassword && !value) {
          callback(new Error('修改密码时原密码不能为空'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  newPassword: [
    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
  ],
  confirmPassword: [
    { validator: validatePass2, trigger: 'blur' }
  ]
}

// 显示个人资料弹窗
const showProfileDialog = () => {
  profileDialogVisible.value = true
  // 从localStorage获取当前登录用户信息
  const currentUser = storage.get(STORAGE_KEYS.USER_INFO)
  profileForm.username = currentUser?.username || 'admin'
  profileForm.avatar = '/images/admin-avatar.png'
  profileForm.oldPassword = ''
  profileForm.newPassword = ''
  profileForm.confirmPassword = ''
}



// 提交个人资料
const handleProfileSubmit = async () => {
  console.log('开始提交个人资料表单')
  if (!profileFormRef.value) {
    console.log('表单引用不存在，退出')
    return
  }

  try {
    console.log('开始表单验证')
    await profileFormRef.value.validate()
    console.log('表单验证通过')
    profileLoading.value = true

    // 头像已固定，无需更新
    console.log('使用固定头像:', profileForm.avatar)

    // 如果修改了密码，调用后端API修改密码
    if (profileForm.newPassword) {
      console.log('检测到密码修改，准备调用API')
      // 密码修改参数已隐藏，避免在控制台输出敏感信息

      try {
        const response = await user.changePassword({
           password: profileForm.newPassword,
           password_confirm: profileForm.confirmPassword,
           old_password: profileForm.oldPassword
         })

        console.log('密码修改API响应:', response)

        // 检查响应状态
        if (response.code === 0 || response.code === 200) {
          ElMessage.success('密码修改成功，请重新登录')
          profileDialogVisible.value = false
          console.log('密码修改成功，准备退出登录')
          // 延迟一下退出登录，让用户看到成功提示
          setTimeout(() => {
            handleLogout()
          }, 1500)
          return
        } else {
          console.log('密码修改失败，错误码:', response.code, '错误信息:', response.msg)
          ElMessage.error(response.msg || '密码修改失败')
          return
        }
      } catch (error) {
        console.error('密码修改API调用失败')
        // 避免在控制台输出包含敏感信息的错误详情

        // 从错误中提取具体的错误信息
        let errorMessage = '密码修改失败，请稍后重试'
        if (error.response?.data?.msg) {
          errorMessage = error.response.data.msg
        } else if (error.response?.data?.message) {
          errorMessage = error.response.data.message
        } else if (error.message) {
          errorMessage = error.message
        }

        console.log('显示错误信息:', errorMessage)
        ElMessage.error(errorMessage)
        return
      }
    }

    console.log('没有密码修改，仅保存其他信息')
    ElMessage.success('保存成功')
    profileDialogVisible.value = false
  } catch (error) {
    console.error('表单验证失败:', error)
  } finally {
    console.log('设置loading为false')
    profileLoading.value = false
  }
}

const loading = ref(false)
const unreadCount = ref(0)
const activeTab = ref('todo')

// 待办事项列表
const todoList = ref([
  {
    id: 1,
    title: '短信服务申请',
    content: '用户 张三 申请开通短信服务',
    createTime: '2024-01-18 10:30:00',
    type: '短信申请',
    isRead: false
  },
  {
    id: 2,
    title: '保险服务申请',
    content: '用户 李四 申请开通保险服务',
    createTime: '2024-01-18 09:30:00',
    type: '保险申请',
    isRead: true
  }
])

// 系统通知列表
const noticeList = ref([
  {
    id: 3,
    title: '授权域名即将过期',
    content: '域名 example.com 将在7天后过期，请及时续期',
    createTime: '2024-01-18 09:00:00',
    type: '授权提醒',
    isRead: true
  },
  {
    id: 4,
    title: '授权域名即将过期',
    content: '域名 test.com 将在15天后过期，请及时续期',
    createTime: '2024-01-17 14:30:00',
    type: '授权提醒',
    isRead: false
  }
])

// 获取标签类型
const getTagType = (type) => {
  const typeMap = {
    '短信申请': 'warning',
    '保险申请': 'success',
    '授权提醒': 'danger'
  }
  return typeMap[type] || 'info'
}

// 计算未读消息数
const calculateUnreadCount = () => {
  const todoUnread = todoList.value.filter(item => !item.isRead).length
  const noticeUnread = noticeList.value.filter(item => !item.isRead).length
  unreadCount.value = todoUnread + noticeUnread
}

// 处理消息点击
const handleMessageClick = (item) => {
  item.isRead = true
  calculateUnreadCount()
  // 根据消息类型跳转到相应页面
  if (item.type === '短信申请') {
    router.push('/service/sms')
  } else if (item.type === '保险申请') {
    router.push('/service/insurance')
  } else if (item.type === '授权提醒') {
    router.push('/auth/list')
  }
}

// 全部已读
const handleReadAll = () => {
  todoList.value.forEach(item => item.isRead = true)
  noticeList.value.forEach(item => item.isRead = true)
  calculateUnreadCount()
}

// 限制显示条数
const limitList = (list, limit = 5) => {
  return list.slice(0, limit)
}

// 监听列表变化，限制显示条数
watch(todoList, (newList) => {
  todoList.value = limitList(newList)
}, { deep: true })

watch(noticeList, (newList) => {
  noticeList.value = limitList(newList)
}, { deep: true })

// 站点设置
const siteSettings = ref({
  siteName: '授权管理系统',
  siteDesc: '专业的授权管理解决方案',
  loginTitle: '授权管理系统',
  loginSubtitle: '欢迎使用授权管理系统',
  copyright: '© 2024 授权管理系统',
  icp: '粤ICP备xxxxxxxx号',
  version: 'v1.0.0',
  techSupport: '技术支持：SAAS科技',
  servicePhone: '400-XXX-XXXX'
})

// 加载站点设置
const loadSiteSettings = async () => {
  try {
    // 先从本地存储加载
    const localSettings = storage.get(STORAGE_KEYS.SITE_SETTINGS)
    if (localSettings) {
      siteSettings.value = {
        ...siteSettings.value,
        ...localSettings
      }
    }

    // 然后从API获取最新设置
    const { settings } = await import('@/api/index.js')
    const response = await settings.getSiteSettings()

    if ((response.code === 0 || response.code === 200) && response.data) {
      const apiSettings = response.data
      siteSettings.value = {
        ...siteSettings.value,
        ...apiSettings
      }
      // 更新本地存储
      storage.set(STORAGE_KEYS.SITE_SETTINGS, apiSettings)
    }
  } catch (error) {
    console.error('加载站点设置失败:', error)
    // 如果API失败，继续使用本地存储的设置
  }
}

onMounted(() => {
  // 加载站点设置
  loadSiteSettings()
})
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;
}

.aside {
  background: #0A1A35;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: none;
  position: relative;
  z-index: 10;
}

.logo {
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;

  h1 {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 0.5px;
  }
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.user-info:hover {
  background-color: #f5f7fa;
}

.username {
  font-size: 14px;
  color: #606266;
}

.main {
  padding: 0 16px 16px;
  background-color: #f5f7fa;
  height: calc(100vh - 50px - 44px - 80px);
  overflow-y: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

:deep(.el-menu) {
  border-right: none;
  background: transparent;
  padding: 16px 12px;
}

:deep(.el-menu-item),
:deep(.el-sub-menu__title) {
  height: 48px;
  line-height: 48px;
  color: #ffffff;
  margin: 4px 0;
  padding: 0 16px !important;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: normal;
  font-size: 14px;

  .el-icon {
    color: #ffffff;
    font-size: 18px;
    margin-right: 12px;
    transition: all 0.3s;
  }

  span {
    font-size: 14px;
    font-weight: normal;
  }

  &:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.1);

    .el-icon {
      color: #ffffff;
    }
  }
}

:deep(.el-menu-item.is-active) {
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.15);
  font-weight: normal;
  box-shadow: none;

  .el-icon {
    color: #ffffff !important;
  }

  span {
    color: #ffffff !important;
  }
}

:deep(.el-sub-menu) {
  .el-menu--inline {
    .el-menu-item {
      &.is-active {
        background: rgba(255, 255, 255, 0.15);
        color: #ffffff !important;
        font-weight: normal;

        .el-icon {
          color: #ffffff !important;
        }

        span {
          color: #ffffff !important;
          font-weight: normal;
        }
      }
    }
  }
}

:deep(.el-menu) {
  .el-menu-item.is-active,
  .el-sub-menu.is-active > .el-sub-menu__title {
    color: #ffffff !important;

    .el-icon {
      color: #ffffff !important;
    }

    span {
      color: #ffffff !important;
    }
  }
}

:deep(.el-menu--collapse) {
  width: 80px;

  .el-menu-item,
  .el-sub-menu__title {
    padding: 0 !important;
    justify-content: center;

    .el-icon {
      margin: 0;
      font-size: 20px;
    }
  }
}

:deep(.el-menu--popup) {
  background: #fff;
  border: none;
  padding: 8px;
  min-width: 180px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

  .el-menu-item {
    height: 40px;
    line-height: 40px;
    margin: 4px 0;
    padding: 0 16px;
    border-radius: 6px;

    &:hover {
      color: rgb(96, 91, 255);
      background: rgba(96, 91, 255, 0.08);
    }

    &.is-active {
      color: rgb(96, 91, 255);
      background: linear-gradient(to right, rgba(96, 91, 255, 0.15), rgba(96, 91, 255, 0.05));
      font-weight: 600;
    }
  }
}

// 滚动条样式
:deep(.el-menu--vertical) {
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 2px;

    &:hover {
      background: rgba(0, 0, 0, 0.2);
    }
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.breadcrumb-container {
  padding: 8px 0;
}

:deep(.el-breadcrumb) {
  line-height: 1;
  font-size: 14px;
}

:deep(.el-breadcrumb__item) {
  display: inline-flex;
  align-items: center;
}

:deep(.el-breadcrumb__inner) {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #909399;
  font-weight: normal;
  transition: all 0.3s;
}

:deep(.el-breadcrumb__inner.is-link) {
  color: #606266;
}

:deep(.el-breadcrumb__inner.is-link:hover) {
  color: rgb(96, 91, 255);
}

:deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
  color: #303133;
  font-weight: 500;
  cursor: default;
}

:deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover) {
  color: #303133;
}

:deep(.el-breadcrumb__separator) {
  margin: 0 8px;
  color: #c0c4cc;
  font-weight: normal;
}

:deep(.el-icon) {
  font-size: 16px;
  margin-right: 4px;
}

:deep(.el-dropdown-menu__item) {
  display: flex !important;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
}

:deep(.el-dropdown-menu__item .el-icon) {
  margin-right: 0;
}

.avatar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.avatar {
  border: 2px solid #dcdfe6;
  background-color: #f5f7fa;
}

:deep(.el-dialog__body) {
  padding-top: 20px;
}

.message-icon {
  margin-right: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.3s;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #f5f7fa;

    svg path {
      fill: #606266;
    }
  }
}

:deep(.notice-badge) {
  .el-badge__content {
    right: 2px;
    top: 2px;
  }
}

:deep(.message-popover) {
  padding: 0;

  .el-popover__title {
    margin: 0;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
  }
}

.message-panel {
  .message-header {
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .message-list {
    max-height: 400px;
    overflow-y: auto;
  }

  .message-item {
    padding: 12px 16px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    transition: background-color 0.3s;

    &:hover {
      background-color: #f5f7fa;
    }

    &.unread {
      background-color: #f0f9ff;
    }

    .message-content {
      flex: 1;
      margin-right: 12px;

      .message-title {
        font-size: 14px;
        color: #303133;
        margin-bottom: 4px;
      }

      .message-desc {
        font-size: 12px;
        color: #909399;
        margin-bottom: 4px;
      }

      .message-time {
        font-size: 12px;
        color: #c0c4cc;
      }
    }
  }

  .message-footer {
    padding: 12px 16px;
    text-align: center;
    border-top: 1px solid #eee;
  }
}

.footer {
  padding: 16px 0;
  background-color: #f5f7fa;

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;

    .copyright {
      font-size: 14px;
      color: #606266;
      margin-bottom: 8px;
    }

    .footer-info {
      font-size: 12px;
      color: #909399;

      .divider {
        margin: 0 8px;
        color: #dcdfe6;
      }
    }
  }
}

.main-footer {
  padding: 16px 20px;
  background-color: #fff;
  border-top: 1px solid #e4e7ed;
  height: 80px;

  .footer-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 14px;

    .footer-info {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #333333;

      .divider {
        color: #dcdfe6;
      }

      .version {
        color: #333333;
      }
    }

    .footer-contact {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #909399;

      .divider {
        color: #dcdfe6;
      }

      .service-phone {
        color: #909399;
      }
    }
  }
}
</style>